var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMetricsMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 18,
    viewBox: "0 0 28 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66699 17.6533L10.667 9.64001L16.0003 14.9733L27.3337 2.22668L25.4537 0.34668L16.0003 10.9733L10.667 5.64001L0.666992 15.6533L2.66699 17.6533Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMetricsMenu);
export default __webpack_public_path__ + "static/media/icon_metrics_menu.bd999c44ba27bba9113c6aa4e757d0ed.svg";
export { ForwardRef as ReactComponent };